// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"396":"9a9b780a2b87bc31","405":"46ab514ad8b4320d","888":"0503aacad2a706f8","915":"9a9b780a2b87bc31"}[chunkId] + ".css";
};